import ListeTransaction from "@/components/transaction/ListeTransaction";


export default [

    {
        path: '/transactions',
        name: 'listeTransactions',
        component: ListeTransaction
    }
]